/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HalJson } from '../../models/hal-json';
import { ItemVariantGroupRequest } from '../../models/item-variant-group-request';

export interface ItemVariantGroupsPost$Params {
  'Active-Tenant-Identifier': string;
      body: ItemVariantGroupRequest
}

export function itemVariantGroupsPost(http: HttpClient, rootUrl: string, params: ItemVariantGroupsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'itemVariantGroupId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, itemVariantGroupsPost.PATH, 'post');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      'itemVariantGroupId'?: string;
      }>;
    })
  );
}

itemVariantGroupsPost.PATH = '/item-variant-groups';
